import { httpClient } from '../http/httpClient'
import { PartnerType } from '@/app/utils/partners.enum'

export interface GetAvailabilityResponse {
  available: boolean
}

export async function getAvailability(cep: string) {
  const { data } = await httpClient
    .get<GetAvailabilityResponse>(`/crefaz/availability/${cep}`, {
      journey: PartnerType.CREFAZ,
    })
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
